export type IPricingCard = {
  planTitle: string;
  supportingText: string;
  price: number;
  keyFeatures: string[];
  bannerText?: string;
};

type PriceMode = 'monthly' | 'annual';

const usePricingCards = (priceMode: PriceMode): IPricingCard[] => {
  return [
    {
      planTitle: 'The Community Plan',
      supportingText: 'Start a community or move one over from a social media group or a chat app.',
      price: priceMode === 'monthly' ? 49 : 41,
      keyFeatures: ['Member Profiles', 'Gamification', 'Chat, Feed, & Events'],
    },
    {
      planTitle: 'The Courses Plan',
      supportingText: 'Add courses, challenges, and resource libraries to a community or membership.',
      price: priceMode === 'monthly' ? 119 : 99,
      keyFeatures: ['Courses & Challenges', 'Basic Automations'],
    },
    {
      planTitle: 'The Business Plan',
      supportingText:
        'Integrate easily with other tools and support your growth with automatic polls & questions and other extras.',
      price: priceMode === 'monthly' ? 219 : 179,
      keyFeatures: ['Unlimited Custom Fields', 'Intermediate Automations'],
      bannerText: 'Your Free Trial',
    },
    {
      planTitle: 'The Growth Plan',
      supportingText: 'Grow your revenue with dedicated services and support and our most advanced automations.',
      price: priceMode === 'monthly' ? 430 : 360,
      keyFeatures: ['More Livestream Hosts', 'Advanced Automations'],
    },
  ];
};

export default usePricingCards;
